<template>
	<ImageAndContent :image-on-right="true" :image-on-top="true">
		<template #content>
			<h2>Novated EV subscription: Unlock the perks</h2>
			<div class="space-y-4 text-lg text-gray-575">
				<p>
					A novated car subscription provides the same benefits as a
					novated lease in terms of salary packaging and tax
					deductions with the flexibility of being able to end the
					subscription with just two weeks' notice.
				</p>
				<p>
					There could be further savings for eligible EVs that are
					zero or low emissions vehicles that are exempt from Fringe
					Benefits Tax (FBT) and first held and used after 1 July
					2022*
				</p>
			</div>
			<div class="mt-8">
				<CarbarLink
					class="text-white"
					:href="'/business/novated-ev-subscription'"
					:underline="false"
				>
					<CarbarButton
						:is-full-width="false"
						:is-outline="true"
						:is-mixed="true"
					>
						More on Novated EV subscription
					</CarbarButton>
				</CarbarLink>
			</div>
			<div class="mt-8">
				<TermsAndConditions :is-full-width="false">
					* The advice given is general advice and does not take into
					account your own objectives, financial situation or needs.
					You should consider if the advice is appropriate for you
					before acting and read all applicable terms and conditions
					of any selected product or service prior to proceeding.
					<CarbarLink
						:href="'/terms-and-conditions/car-subscription'"
						target="_blank"
						class="text-xsm"
						text="Terms and conditions"
					/>
					apply.
				</TermsAndConditions>
			</div>
		</template>
		<template #image>
			<CarbarImage
				image="img/electric-vehicle/img-novatedEV.webp"
				alt-text="Car with plants"
			/>
		</template>
	</ImageAndContent>
</template>
<script setup>
import CarbarImage from '@/components/CarbarImage.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'
import CarbarButton from '@/components/buttons/CarbarButton.vue'
import ImageAndContent from '@/components/sections/ImageAndContent.vue'
import TermsAndConditions from '@/components/fineprint/TermsAndConditions.vue'
</script>
